import React, { Component } from "react"
import styled from "styled-components"
import {
  ACTIVE_TEXT,
  SECONDARY_TEXT,
  PRIMARY_TEXT,
  TINY_SHADOW
} from "./consts/colors.js"

const TinyPriceContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0px;
  h3 {
    padding-right: 5px;
    margin: 0px;
  }
  h1 {
    font-size: 48px;
    padding-right: 10px;
    margin: 0px;
  }
  h5 {
    position: relative;
    top: -10px;
    margin: 0px;
  }
`
const TinyPrice = props => (
  <TinyPriceContainer>
    <h3>$</h3>
    <h1>0</h1>
    <h5>.00</h5>
  </TinyPriceContainer>
)

export default TinyPrice



// WEBPACK FOOTER //
// ./src/components/TinyPrice.js